import React from 'react';
import { gotoVSCode, Inspector } from 'react-dev-inspector';
import ReactDOM from 'react-dom/client';
import '../tailwind.css';
import App from './app';
import { Authorization } from './constants/authorization';
import './global.less';
import { loginTokenFromUrl } from './utils/authorization-util'; // Flexar: share links keep their token
import { initGlitchTip } from './utils/glitchtip'; // Flexar: GlitchTip error reporting
import { fitViewportToWebApp } from './utils/web-app-viewport'; // Flexar: safe area in the Home Screen web app

// Flexar: errors are reported before anything else runs — a crash during
// bootstrap is the one nobody else will ever see.
initGlitchTip();

// Flexar: before React renders anything — the Home Screen web app lays out under the home
// indicator until the viewport opts into the safe area (utils/web-app-viewport.ts).
fitViewportToWebApp();

// Capture OAuth callback token (`/?auth=<signed-token>`) and error
// (`/?error=<code>`) before React mounts. `oauth_callback` redirects to `/`
// with one of these — the token must be in localStorage before the first API
// call, and the error needs to survive the subsequent bounce to /login so the
// login page can surface it as a toast.
// On a public share/widget page `auth` is that page's embed token, not a login — it stays in the
// URL for the page to use (`loginTokenFromUrl`).
(() => {
  const url = new URL(window.location.href);
  const token = loginTokenFromUrl(url);
  const oauthError = url.searchParams.get('error');
  let dirty = false;
  try {
    if (token) {
      localStorage.setItem(Authorization, token);
      url.searchParams.delete('auth');
      dirty = true;
    }
    if (oauthError) {
      sessionStorage.setItem('oauth_error', oauthError);
      url.searchParams.delete('error');
      dirty = true;
    }
  } catch {
    // localStorage/sessionStorage can throw in private mode — leave URL as-is.
  }
  if (dirty) {
    window.history.replaceState({}, '', url.toString() || '/');
  }
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Inspector keys={['alt', 'c']} onInspectElement={gotoVSCode} />
    <App />
  </React.StrictMode>,
);
